document.addEventListener('DOMContentLoaded', () => {
  const stickyBar = document.getElementById('MpcStickyCart');

  if (!stickyBar) return;

  const originalAddButton = document.querySelector(
    'product-form button[name="add"]'
  );

  if (!originalAddButton) return;

  // Al principio permanece oculto
  stickyBar.style.display = 'none';

  // Mostrar la barra cuando el botón original deja de verse
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        stickyBar.style.display = 'none';
      } else {
        stickyBar.style.display = 'block';
      }
    },
    {
      threshold: 0.1
    }
  );

  observer.observe(originalAddButton);

  // El botón fijo ejecuta el botón original
  const stickyButton = stickyBar.querySelector('.mpc-sticky-cart__button');

  if (stickyButton) {
    stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      originalAddButton.click();
    });
  }
});